import type { RouteRole } from './types'

/** Org sub-route access by effective role (admins bypass via adminBypass on parent). */
export const ORG_PATH_ACCESS: Record<string, RouteRole[]> = {
  '/org/dashboard': ['admin', 'organization_owner', 'organization_member'],
  '/org/members': ['admin', 'organization_owner'],
  '/org/settings': ['admin', 'organization_owner'],
  '/org/billing': ['admin', 'organization_owner'],
}

export function canAccessOrgPath(
  pathname: string,
  effectiveRole: RouteRole,
  isActualAdmin: boolean,
): boolean {
  if (isActualAdmin) return true

  const normalized = pathname.replace(/\/+$/, '') || '/'
  const allowed = ORG_PATH_ACCESS[normalized]
  if (!allowed) return false

  return allowed.includes(effectiveRole)
}

export function orgNavItemsForRole(
  effectiveRole: RouteRole,
  isActualAdmin: boolean,
): Array<{ to: string; label: string }> {
  const all = [
    { to: '/org/dashboard', label: 'Dashboard' },
    { to: '/org/members', label: 'Members' },
    { to: '/org/settings', label: 'Settings' },
    { to: '/org/billing', label: 'Billing' },
  ]

  return all.filter((item) => canAccessOrgPath(item.to, effectiveRole, isActualAdmin))
}
